(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["address-fields"] && !Shopify.designMode) return;
  try {
    class AddressForm extends HTMLElement {
    connectedCallback() {
      this.country = document.getElementById(this.dataset.countrySelect);
      this.province = document.getElementById(this.dataset.provinceSelect);
      this.wrap = this.querySelector('[data-province-wrap]');
      if (!this.country || !this.province) return;
      const preset = this.country.dataset.default;
      if (preset && preset !== 'United Kingdom' || preset) {
        const option = [...this.country.options].find((o) => o.value === preset || o.textContent === preset);
        if (option) option.selected = true;
      }
      this.country.addEventListener('change', () => this.sync(false));
      this.sync(true);
    }

    sync(initial) {
      const option = this.country.options[this.country.selectedIndex];
      let provinces = [];
      try { provinces = JSON.parse(option?.dataset.provinces || '[]'); } catch (error) { provinces = []; }
      this.province.replaceChildren();
      if (!provinces.length) {
        this.wrap.hidden = true;
        return;
      }
      provinces.forEach(([value, label]) => {
        const item = document.createElement('option');
        item.value = value;
        item.textContent = label;
        if (initial && value === this.dataset.province) item.selected = true;
        this.province.append(item);
      });
      this.wrap.hidden = false;
    }
  }

  if (!customElements.get('address-form')) {
    customElements.define('address-form', AddressForm);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["carousel-controls"] && !Shopify.designMode) return;
  try {
    class ThemeCarousel extends HTMLElement {
    connectedCallback() {
      this.attach(this.querySelector('[data-carousel-track]'));
    }

    /* Bind the element to the track it drives. Split out of `connectedCallback` so a host
       whose track is replaced under it can bind the new one (#110: the reviews app renders
       its list again on every sort and page change). Everything attached to the previous
       track goes with its abort controller, so binding twice never doubles a listener. */
    attach(track) {
      if (!track || track === this.track) return;
      this.binding?.abort();
      this.binding = new AbortController();
      const { signal } = this.binding;
      this.track = track;
      this.prev = this.querySelector('[data-carousel-prev]');
      this.next = this.querySelector('[data-carousel-next]');
      track.setAttribute('tabindex', '0');
      this.prev?.addEventListener('click', () => this.scrollByPage(-1), { signal });
      this.next?.addEventListener('click', () => this.scrollByPage(1), { signal });
      track.addEventListener('scroll', () => this.update(), { passive: true, signal });
      track.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') { event.preventDefault(); this.scrollByPage(1); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); this.scrollByPage(-1); }
      }, { signal });
      // Keyboard: a focused card that is cut at an edge scrolls into view (the browser only
      // does it when the card is fully out of view).
      track.addEventListener('focusin', (event) => {
        const item = [...track.children].find((child) => child.contains(event.target));
        item?.scrollIntoView({ inline: 'nearest', block: 'nearest' });
      }, { signal });
      this.centred = this.classList.contains('carousel--centred');
      if (this.centred) {
        ['pointerdown', 'wheel', 'keydown', 'touchstart'].forEach((type) => {
          track.addEventListener(type, () => { this.userScrolled = true; }, { passive: true, signal });
        });
      }
      // Mouse drag (#99): the shared helper follows the pointer and settles on the nearest
      // snap point; a drag starts with a pointerdown, which unparks the centred row above.
      window.theme?.dragScroll?.(track);
      const resize = new ResizeObserver(() => { this.update(); this.centre(); });
      resize.observe(track);
      signal.addEventListener('abort', () => resize.disconnect());
      this.update();
      this.centre();
    }

    /* Centred mode: park the scroll at the middle of the row so both edges are cut alike,
       until the visitor scrolls; the CSS snap keeps the middle card centred. */
    centre() {
      if (!this.centred || this.userScrolled || !window.matchMedia('(min-width: 60rem)').matches) return;
      const max = this.track.scrollWidth - this.track.clientWidth;
      if (max > 1) this.track.scrollTo({ left: max / 2, behavior: 'instant' });
    }

    scrollByPage(direction) {
      const item = this.track.firstElementChild;
      const style = getComputedStyle(this.track);
      const gap = parseFloat(style.columnGap) || 0;
      // The column the cards fill: the track minus its padding (the page margins when full width).
      const inner = this.track.clientWidth - (parseFloat(style.paddingLeft) || 0) - (parseFloat(style.paddingRight) || 0);
      const step = item ? item.getBoundingClientRect().width + gap : inner;
      const visible = Math.max(1, Math.floor((inner + gap + 1) / step));
      this.track.scrollBy({ left: direction * visible * step, behavior: 'smooth' });
    }

    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const overflowing = max > 1;
      this.toggleAttribute('data-overflowing', overflowing);
      if (this.prev) this.prev.disabled = !overflowing || this.track.scrollLeft <= 1;
      if (this.next) this.next.disabled = !overflowing || this.track.scrollLeft >= max - 1;
      const thumb = overflowing ? Math.max(0.1, this.track.clientWidth / this.track.scrollWidth) : 1;
      const progress = overflowing ? Math.min(1, Math.max(0, this.track.scrollLeft / max)) : 0;
      this.style.setProperty('--carousel-thumb', thumb.toFixed(3));
      this.style.setProperty('--carousel-progress', progress.toFixed(3));
    }
  }

  if (!customElements.get('theme-carousel')) {
    customElements.define('theme-carousel', ThemeCarousel);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-lines"] && !Shopify.designMode) return;
  try {
    class CartContent extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      document.addEventListener('cart:updated', () => this.refresh(), { signal: this.controller.signal });
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    async refresh() {
      const id = this.dataset.sectionId;
      if (!id) return;
      const url = new URL(this.dataset.sectionUrl || window.Shopify?.routes?.root || '/', window.location.origin);
      url.searchParams.set('sections', id);
      try {
        const json = await (await fetch(url)).json();
        const doc = new DOMParser().parseFromString(json[id] || '', 'text/html');
        const fresh = doc.querySelector('[data-cart-content]');
        if (!fresh) return;
        const active = this.contains(document.activeElement) ? document.activeElement : null;
        const focusKey = active?.closest('[data-line-key]')?.dataset.lineKey;
        const focusSelector = active?.dataset.quantityIncrease !== undefined ? '[data-quantity-increase]' : active?.dataset.quantityDecrease !== undefined ? '[data-quantity-decrease]' : '[data-quantity-field]';
        this.dataset.firstProductId = fresh.dataset.firstProductId || '';
        this.replaceChildren(...fresh.childNodes);
        this.dispatchEvent(new CustomEvent('cart:rendered', { bubbles: true }));
        if (focusKey) this.querySelector(`[data-line-key="${focusKey}"] ${focusSelector}`)?.focus();
      } catch (error) {
        console.warn('cart-content: refresh failed', error);
      }
    }
  }

  class CartItems extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', (event) => {
        const field = event.target.closest('[data-quantity-field]');
        const line = field?.closest('[data-line-key]');
        if (line) this.change(line.dataset.lineKey, Number(field.value));
      });
      this.addEventListener('click', (event) => {
        const remove = event.target.closest('[data-line-remove]');
        if (!remove) return;
        event.preventDefault();
        this.change(remove.dataset.lineKey, 0);
      });
    }

    money(cents, currency) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: currency || 'GBP' }).format(cents / 100);
    }

    async change(key, quantity) {
      this.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity }),
        });
        const cart = await response.json();
        if (!response.ok) {
          document.dispatchEvent(new CustomEvent('cart:error', { detail: { message: cart.description || cart.message, source: this } }));
          this.closest('cart-content')?.refresh();
          return;
        }
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { item_count: cart.item_count, total_price: cart.total_price, total_price_formatted: this.money(cart.total_price, cart.currency), cart, source: this },
        }));
      } catch (error) {
        this.removeAttribute('aria-busy');
      }
    }
  }

  if (!customElements.get('cart-content')) {
    customElements.define('cart-content', CartContent);
  }

  if (!customElements.get('cart-items')) {
    customElements.define('cart-items', CartItems);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-progress"] && !Shopify.designMode) return;
  try {
    class OfferProgress extends HTMLElement {
    connectedCallback() {
      if (this.closest('cart-content')) return;
      this.controller = new AbortController();
      document.addEventListener('cart:updated', () => this.refresh(), { signal: this.controller.signal });
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    async refresh() {
      const id = this.dataset.sectionId;
      if (!id) return;
      const url = new URL(this.dataset.sectionUrl || window.location.pathname, window.location.origin);
      url.searchParams.set('sections', id);
      try {
        const json = await (await fetch(url)).json();
        const doc = new DOMParser().parseFromString(json[id] || '', 'text/html');
        const fresh = doc.querySelector('[data-offer-progress]');
        if (fresh) this.replaceWith(fresh);
      } catch (error) {
        console.warn('offer-progress: refresh failed', error);
      }
    }
  }

  if (!customElements.get('offer-progress')) {
    customElements.define('offer-progress', OfferProgress);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["customer-layout"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.customer [data-focus]').forEach((node) => node.focus());
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["predictive-search"] && !Shopify.designMode) return;
  try {
    class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-predictive-input]');
      this.results = this.querySelector('[data-predictive-results]');
      this.status = this.querySelector('[data-predictive-status]');
      this.clearButton = this.querySelector('[data-predictive-clear]');
      this.sectionId = this.dataset.sectionId;
      this.timer = null;
      this.controller = null;
      this.activeIndex = -1;

      this.input.addEventListener('input', () => this.onInput());
      this.input.addEventListener('focus', () => { if (this.results.innerHTML.trim()) this.show(); });
      this.input.addEventListener('keydown', (event) => this.onKeydown(event));
      // Escape anywhere in the element (a focused result included) closes the panel and
      // hands focus back to the field.
      this.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || this.results.hidden) return;
        event.preventDefault();
        event.stopPropagation();
        // Focus first: focusing the field re-opens a panel that has results.
        this.input.focus();
        this.hide();
      });
      this.clearButton?.addEventListener('click', () => this.clear());
      document.addEventListener('click', (event) => { if (!this.contains(event.target)) this.hide(); });
      this.results.addEventListener('mouseover', (event) => {
        const option = event.target.closest('[data-predictive-option]');
        if (option) this.setActive(this.options().indexOf(option));
      });
    }

    onInput() {
      const terms = this.input.value.trim();
      this.clearButton.hidden = terms.length === 0;
      clearTimeout(this.timer);
      if (terms.length < 2) {
        this.hide();
        return;
      }
      this.timer = setTimeout(() => this.fetchResults(terms), 300);
    }

    async fetchResults(terms) {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      const params = new URLSearchParams({
        q: terms,
        'resources[type]': 'product,collection,article,page',
        'resources[limit]': '4',
        'resources[limit_scope]': 'each',
        'resources[options][prefix]': 'last',
        section_id: this.sectionId,
      });
      this.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}search/suggest?${params}`, { signal });
        if (!response.ok) throw new Error(response.status);
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const content = doc.querySelector('.predictive-search__results');
        if (!content || this.input.value.trim() !== terms) return;
        this.results.replaceChildren(content);
        this.activeIndex = -1;
        this.show();
        const count = Number(content.dataset.predictiveCount || 0);
        const template = count === 1 ? this.dataset.statusOne : this.dataset.statusOther;
        this.status.textContent = count === 0
          ? this.results.querySelector('.predictive-search__empty')?.textContent.replace(/\s+/g, ' ').trim() || ''
          : template.replace('[count]', count).replace('[terms]', terms);
      } catch (error) {
        if (error.name !== 'AbortError') this.hide();
      } finally {
        if (!signal.aborted) this.removeAttribute('aria-busy');
      }
    }

    options() {
      return [...this.results.querySelectorAll('[data-predictive-option]')];
    }

    setActive(index) {
      const options = this.options();
      options.forEach((option) => option.closest('li')?.classList.remove('is-active'));
      this.activeIndex = index;
      const active = options[index];
      if (active) {
        active.closest('li')?.classList.add('is-active');
        active.scrollIntoView({ block: 'nearest' });
        this.input.setAttribute('aria-activedescendant', active.id || (active.id = `predictive-option-${index}`));
      } else {
        this.input.removeAttribute('aria-activedescendant');
      }
    }

    onKeydown(event) {
      if (this.results.hidden) return;
      const options = this.options();
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        this.setActive(Math.min(this.activeIndex + 1, options.length - 1));
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        this.setActive(Math.max(this.activeIndex - 1, -1));
      } else if (event.key === 'Enter' && this.activeIndex >= 0) {
        event.preventDefault();
        options[this.activeIndex].click();
      }
    }

    show() {
      this.results.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
    }

    hide() {
      this.results.hidden = true;
      this.input.setAttribute('aria-expanded', 'false');
      this.setActive(-1);
    }

    clear() {
      this.input.value = '';
      this.clearButton.hidden = true;
      this.results.replaceChildren();
      this.hide();
      this.input.focus();
    }
  }

  if (!customElements.get('predictive-search')) {
    customElements.define('predictive-search', PredictiveSearch);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-form"] && !Shopify.designMode) return;
  try {
    class ProductForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-product-form]');
      this.variantInput = this.querySelector('[data-product-form-variant]');
      this.quantityInput = this.querySelector('[data-quantity-field], [data-product-form-quantity]');
      this.submitButton = this.querySelector('[data-product-form-submit]');
      this.label = this.querySelector('[data-product-form-label]');
      this.price = this.querySelector('[data-product-form-price]');
      this.priceWrap = this.querySelector('[data-product-form-price-wrap]');
      this.error = this.querySelector('[data-product-form-error]');
      this.bis = this.querySelector('[data-product-form-bis]');
      this.bisTrigger = this.querySelector('[data-product-form-bis-trigger]');
      this.bisTrigger?.addEventListener('click', (event) => event.preventDefault());
      this.form?.addEventListener('submit', (event) => this.onSubmit(event));
      this.quantityInput?.addEventListener('change', () => this.renderPrice());
      this.section = this.closest('[data-product-section]');
      this.section?.addEventListener('variant:changed', (event) => this.setVariant(event.detail.variant));
    }

    get quantity() {
      return Math.max(1, Number(this.quantityInput?.value) || 1);
    }

    money(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: this.dataset.currency || 'GBP' }).format(cents / 100);
    }

    setVariant(variant) {
      if (!variant) return;
      this.variantInput.value = variant.id;
      this.dataset.price = variant.price;
      const available = Boolean(variant.available);
      this.submitButton.disabled = !available;
      this.label.textContent = available ? this.submitButton.dataset.labelAdd : this.submitButton.dataset.labelSoldOut;
      if (this.priceWrap) this.priceWrap.hidden = !available;
      if (this.bis) this.bis.hidden = available;
      if (this.bisTrigger) this.bisTrigger.dataset.variantId = variant.id;
      if (this.quantityInput?.matches('[data-quantity-field]')) {
        const limited = variant.inventory_management === 'shopify' && variant.inventory_policy === 'deny';
        if (limited) this.quantityInput.max = Math.max(1, variant.inventory_quantity);
        else this.quantityInput.removeAttribute('max');
        this.quantityInput.closest('quantity-input')?.sync?.();
      }
      this.renderPrice();
    }

    renderPrice() {
      if (this.price) this.price.textContent = this.money(Number(this.dataset.price) * this.quantity);
    }

    async onSubmit(event) {
      event.preventDefault();
      if (this.submitButton.disabled || this.busy) return;
      this.setBusy(true);
      this.error.hidden = true;
      const root = window.Shopify?.routes?.root || '/';
      // An optional field left empty (the CLP scent name) adds no property: the line keeps the
      // same key as one added from a card, so the cart never splits the same product in two.
      const body = new FormData(this.form);
      for (const [name, value] of [...body]) {
        if (!name.startsWith('properties[')) continue;
        const text = String(value).trim();
        if (text === '') body.delete(name);
        else body.set(name, text);
      }
      try {
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body,
        });
        const data = await response.json();
        if (!response.ok) {
          this.showError(data.description || data.message || this.submitButton.dataset.labelSoldOut);
          return;
        }
        const cart = await (await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })).json();
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { item_count: cart.item_count, total_price: cart.total_price, total_price_formatted: this.money(cart.total_price), cart, added: data, added_quantity: this.quantity, source: this },
        }));
        this.flash(this.submitButton.dataset.labelAdded);
      } catch (error) {
        this.showError(this.submitButton.dataset.labelSoldOut);
      } finally {
        this.setBusy(false);
      }
    }

    setBusy(busy) {
      this.busy = busy;
      this.submitButton.setAttribute('aria-busy', String(busy));
    }

    showError(message) {
      const detail = {
        message,
        source: this,
        item: { title: this.dataset.productTitle, type: this.dataset.productType, image: this.dataset.productImage, quantity: this.quantity, price: Number(this.dataset.price) * this.quantity },
      };
      if (!document.querySelector('toast-region')) {
        this.error.textContent = message;
        this.error.hidden = false;
      }
      document.dispatchEvent(new CustomEvent('cart:error', { detail }));
    }

    flash(text) {
      const original = this.label.textContent;
      this.label.textContent = text;
      clearTimeout(this.flashTimer);
      this.flashTimer = setTimeout(() => { this.label.textContent = original; }, 2000);
    }
  }

  if (!customElements.get('product-form')) {
    customElements.define('product-form', ProductForm);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quantity-input"] && !Shopify.designMode) return;
  try {
    class QuantityInput extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-quantity-field]');
      this.decrease = this.querySelector('[data-quantity-decrease]');
      this.increase = this.querySelector('[data-quantity-increase]');
      if (!this.input || !this.decrease || !this.increase) return;
      this.decrease.addEventListener('click', () => this.stepBy(-1));
      this.increase.addEventListener('click', () => this.stepBy(1));
      this.input.addEventListener('change', () => this.sync());
      this.sync();
    }

    get min() {
      return this.input.min === '' ? -Infinity : Number(this.input.min);
    }

    get max() {
      return this.input.max === '' ? Infinity : Number(this.input.max);
    }

    get step() {
      return Number(this.input.step) || 1;
    }

    stepBy(direction) {
      const current = Number(this.input.value) || 0;
      const next = Math.min(this.max, Math.max(this.min, current + direction * this.step));
      if (next === current) return;
      this.input.value = next;
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    sync() {
      const value = Number(this.input.value);
      if (Number.isNaN(value)) {
        this.input.value = Math.max(this.min, 0);
      } else if (value < this.min || value > this.max) {
        this.input.value = Math.min(this.max, Math.max(this.min, value));
      }
      const current = Number(this.input.value);
      this.decrease.disabled = current <= this.min;
      this.increase.disabled = current >= this.max;
    }
  }

  if (!customElements.get('quantity-input')) {
    customElements.define('quantity-input', QuantityInput);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["smile-points"] && !Shopify.designMode) return;
  try {
    class SmilePoints extends HTMLElement {
    connectedCallback() {
      if (window.Smile) this.load();
      else document.addEventListener('smile-js-loaded', () => this.load(), { once: true });
    }

    async load() {
      try {
        const wallet = await window.Smile?.customerPointsWallet?.get?.();
        const balance = wallet?.pointsBalance ?? wallet?.points_balance ?? wallet?.balance;
        if (typeof balance !== 'number') return;
        this.textContent = this.dataset.template.replace('[points]', balance.toLocaleString(document.documentElement.lang || 'en'));
      } catch (error) {
        /* no customer or Smile unavailable: keep the fallback */
      }
    }
  }

  if (!customElements.get('smile-points')) {
    customElements.define('smile-points', SmilePoints);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["toast-region"] && !Shopify.designMode) return;
  try {
    class ToastRegion extends HTMLElement {
    connectedCallback() {
      this.template = this.querySelector('[data-toast-template]');
      this.addedLabel = this.querySelector('[data-toast-added]')?.textContent || '';
      this.duration = 6000;
      document.addEventListener('cart:updated', (event) => this.onAdded(event.detail));
      document.addEventListener('cart:error', (event) => this.onError(event.detail));
      this.addEventListener('click', (event) => {
        const close = event.target.closest('[data-toast-close]');
        if (close) this.dismiss(close.closest('.toast'));
      });
    }

    onAdded(detail) {
      const item = detail?.added;
      if (!item) return;
      const quantity = detail.added_quantity || item.quantity || 1;
      this.show({
        image: item.image,
        type: item.product_type,
        title: item.product_title,
        meta: [item.variant_title, quantity > 1 ? `× ${quantity}` : ''].filter(Boolean).join(' '),
        status: this.addedLabel,
        price: this.money((item.final_price ?? item.price) * quantity, detail.cart?.currency),
      });
    }

    onError(detail) {
      const item = detail?.item || {};
      this.show({
        image: item.image,
        type: item.type,
        title: item.title,
        meta: item.quantity > 1 ? `× ${item.quantity}` : '',
        status: detail?.message || '',
        price: item.price ? this.money(item.price) : '',
        error: true,
      });
    }

    money(cents, currency) {
      if (cents == null) return '';
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: currency || window.Shopify?.currency?.active || 'GBP' }).format(cents / 100);
    }

    show(data) {
      const fragment = this.template.content.cloneNode(true);
      const toast = fragment.querySelector('.toast');
      if (data.error) toast.classList.add('toast--error');
      const image = toast.querySelector('[data-toast-image]');
      if (data.image) {
        const img = document.createElement('img');
        img.src = data.image;
        img.alt = '';
        img.width = 80;
        img.height = 80;
        image.append(img);
      }
      const fill = (key, value) => {
        const node = toast.querySelector(`[data-toast-${key}]`);
        if (value) node.textContent = value;
        else node.remove();
      };
      fill('type', data.type);
      fill('title', data.title);
      fill('meta', data.meta);
      fill('status', data.status);
      fill('price', data.price);
      this.append(fragment);
      const node = this.lastElementChild;
      node.timer = setTimeout(() => this.dismiss(node), this.duration);
      node.addEventListener('mouseenter', () => clearTimeout(node.timer));
      node.addEventListener('mouseleave', () => { node.timer = setTimeout(() => this.dismiss(node), this.duration / 2); });
    }

    dismiss(node) {
      if (!node) return;
      clearTimeout(node.timer);
      node.remove();
    }
  }

  if (!customElements.get('toast-region')) {
    customElements.define('toast-region', ToastRegion);
  }
  } catch(e) { console.error(e); }
})();

})();
